import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, RotateCcwIcon, ClipboardCheckIcon, AlertCircleIcon, CheckIcon } from 'lucide-react';
export function WarrantyPage() {
  const warrantyTerms = [{
    category: 'Басейни та обладнання',
    period: '24 місяці',
    description: 'Офіційна гарантія виробника на всі каркасні та надувні басейни, насоси, фільтри'
  }, {
    category: 'Електрообладнання',
    period: '12-36 місяців',
    description: 'Гарантія на печі для саун, нагрівачі, роботи-пилососи залежно від виробника'
  }, {
    category: 'Хімія та витратні матеріали',
    period: 'До закінчення терміну придатності',
    description: 'Гарантія якості на всю хімію для басейнів та саун'
  }, {
    category: 'Аксесуари',
    period: '6-12 місяців',
    description: 'Гарантія на сходи, термометри, освітлення та інші аксесуари'
  }];
  const returnSteps = [{
    step: 1,
    title: "Зв'яжіться з нами",
    description: 'Напишіть у Telegram або зателефонуйте протягом 14 днів з моменту отримання'
  }, {
    step: 2,
    title: 'Опишіть причину',
    description: 'Розкажіть, чому хочете повернути товар, додайте фото за потреби'
  }, {
    step: 3,
    title: 'Відправте товар',
    description: 'Упакуйте товар в оригінальну упаковку та відправте Новою Поштою'
  }, {
    step: 4,
    title: 'Отримайте кошти',
    description: 'Після перевірки товару повернемо кошти протягом 3-5 робочих днів'
  }];
  return <main className="min-h-screen bg-slate-50" data-id="element-1143">
      {/* Breadcrumbs */}
      <div className="bg-white border-b border-slate-100" data-id="element-1144">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-1145">
          <nav className="flex items-center gap-2 text-sm" data-id="element-1146">
            <Link to="/" className="text-slate-500 hover:text-slate-700" data-id="element-1147">
              Головна
            </Link>
            <span className="text-slate-300" data-id="element-1148">/</span>
            <span className="text-slate-900 font-medium" data-id="element-1149">
              Гарантія та повернення
            </span>
          </nav>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-1150">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-1151">
          <h1 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-1152">
            Гарантія та повернення
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-1153">
            Ми гарантуємо якість усіх товарів та забезпечуємо просте повернення
          </p>
        </div>

        {/* Warranty Section */}
        <section className="mb-16" data-id="element-1154">
          <div className="flex items-center gap-3 mb-8" data-id="element-1155">
            <div className="w-12 h-12 bg-sky-100 rounded-xl flex items-center justify-center" data-id="element-1156">
              <ShieldCheckIcon className="w-6 h-6 text-sky-600" data-id="element-1157" />
            </div>
            <h2 className="text-2xl font-bold text-slate-900" data-id="element-1158">
              Гарантійні умови
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1159">
            {warrantyTerms.map((term, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-2xl shadow-md p-6" data-id="element-1160">
                <div className="flex items-start justify-between mb-3" data-id="element-1161">
                  <h3 className="text-lg font-semibold text-slate-900" data-id="element-1162">
                    {term.category}
                  </h3>
                  <span className="px-3 py-1 bg-sky-100 text-sky-700 rounded-lg text-sm font-medium" data-id="element-1163">
                    {term.period}
                  </span>
                </div>
                <p className="text-slate-600" data-id="element-1164">{term.description}</p>
              </motion.div>)}
          </div>
        </section>

        {/* Return Policy */}
        <section className="mb-16" data-id="element-1165">
          <div className="flex items-center gap-3 mb-8" data-id="element-1166">
            <div className="w-12 h-12 bg-sky-100 rounded-xl flex items-center justify-center" data-id="element-1167">
              <RotateCcwIcon className="w-6 h-6 text-sky-600" data-id="element-1168" />
            </div>
            <h2 className="text-2xl font-bold text-slate-900" data-id="element-1169">
              Повернення товару
            </h2>
          </div>

          <div className="bg-white rounded-2xl shadow-md p-6 mb-8" data-id="element-1170">
            <p className="text-slate-600 mb-6" data-id="element-1171">
              Ви можете повернути товар належної якості протягом{' '}
              <strong data-id="element-1172">14 днів</strong> з моменту отримання, якщо він не був у
              використанні, збережено товарний вигляд та оригінальну упаковку.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-1173">
              {returnSteps.map((step, index) => <div key={index} className="relative" data-id="element-1174">
                  <div className="flex items-center gap-3 mb-3" data-id="element-1175">
                    <span className="w-8 h-8 bg-sky-500 text-white rounded-full flex items-center justify-center text-sm font-bold" data-id="element-1176">
                      {step.step}
                    </span>
                    {index < returnSteps.length - 1 && <div className="hidden md:block absolute top-4 left-10 w-full h-0.5 bg-slate-200" data-id="element-1177" />}
                  </div>
                  <h4 className="font-semibold text-slate-900 mb-2" data-id="element-1178">
                    {step.title}
                  </h4>
                  <p className="text-sm text-slate-600" data-id="element-1179">{step.description}</p>
                </div>)}
            </div>
          </div>
        </section>

        {/* What's Covered */}
        <section className="mb-16" data-id="element-1180">
          <div className="flex items-center gap-3 mb-8" data-id="element-1181">
            <div className="w-12 h-12 bg-sky-100 rounded-xl flex items-center justify-center" data-id="element-1182">
              <ClipboardCheckIcon className="w-6 h-6 text-sky-600" data-id="element-1183" />
            </div>
            <h2 className="text-2xl font-bold text-slate-900" data-id="element-1184">
              Що покриває гарантія
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1185">
            <div className="bg-emerald-50 rounded-2xl p-6" data-id="element-1186">
              <h3 className="font-semibold text-emerald-800 mb-4 flex items-center gap-2" data-id="element-1187">
                <CheckIcon className="w-5 h-5" data-id="element-1188" />
                Гарантія покриває
              </h3>
              <ul className="space-y-3" data-id="element-1189">
                <li className="flex items-start gap-3 text-emerald-700" data-id="element-1190">
                  <CheckIcon className="w-4 h-4 mt-1 flex-shrink-0" data-id="element-1191" />
                  <span data-id="element-1192">Виробничі дефекти матеріалів</span>
                </li>
                <li className="flex items-start gap-3 text-emerald-700" data-id="element-1193">
                  <CheckIcon className="w-4 h-4 mt-1 flex-shrink-0" data-id="element-1194" />
                  <span data-id="element-1195">Несправності електрообладнання</span>
                </li>
                <li className="flex items-start gap-3 text-emerald-700" data-id="element-1196">
                  <CheckIcon className="w-4 h-4 mt-1 flex-shrink-0" data-id="element-1197" />
                  <span data-id="element-1198">Порушення цілісності при транспортуванні</span>
                </li>
                <li className="flex items-start gap-3 text-emerald-700" data-id="element-1199">
                  <CheckIcon className="w-4 h-4 mt-1 flex-shrink-0" data-id="element-1200" />
                  <span data-id="element-1201">Невідповідність заявленим характеристикам</span>
                </li>
              </ul>
            </div>

            <div className="bg-red-50 rounded-2xl p-6" data-id="element-1202">
              <h3 className="font-semibold text-red-800 mb-4 flex items-center gap-2" data-id="element-1203">
                <AlertCircleIcon className="w-5 h-5" data-id="element-1204" />
                Гарантія не покриває
              </h3>
              <ul className="space-y-3" data-id="element-1205">
                <li className="flex items-start gap-3 text-red-700" data-id="element-1206">
                  <AlertCircleIcon className="w-4 h-4 mt-1 flex-shrink-0" data-id="element-1207" />
                  <span data-id="element-1208">Механічні пошкодження з вини покупця</span>
                </li>
                <li className="flex items-start gap-3 text-red-700" data-id="element-1209">
                  <AlertCircleIcon className="w-4 h-4 mt-1 flex-shrink-0" data-id="element-1210" />
                  <span data-id="element-1211">Пошкодження через неправильну експлуатацію</span>
                </li>
                <li className="flex items-start gap-3 text-red-700" data-id="element-1212">
                  <AlertCircleIcon className="w-4 h-4 mt-1 flex-shrink-0" data-id="element-1213" />
                  <span data-id="element-1214">Природний знос витратних матеріалів</span>
                </li>
                <li className="flex items-start gap-3 text-red-700" data-id="element-1215">
                  <AlertCircleIcon className="w-4 h-4 mt-1 flex-shrink-0" data-id="element-1216" />
                  <span data-id="element-1217">Самостійний ремонт або модифікації</span>
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Contact for Warranty */}
        <section data-id="element-1218">
          <div className="bg-sky-50 rounded-2xl p-8 text-center" data-id="element-1219">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-1220">
              Потрібна допомога з гарантією?
            </h2>
            <p className="text-slate-600 mb-6 max-w-xl mx-auto" data-id="element-1221">
              Напишіть нам у Telegram з описом проблеми та фото товару —
              допоможемо вирішити питання якнайшвидше
            </p>
            <a href="https://t.me/aquapools_if" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 bg-sky-500 text-white rounded-xl font-medium hover:bg-sky-600 transition-colors" data-id="element-1222">
              Написати в Telegram
            </a>
          </div>
        </section>
      </div>
    </main>;
}